// might look useless, but it is actually required because it allows events to be passed between components. :D

import Vue from 'vue'
export default new Vue()
